import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./styles.css";
import { Layout, Menu } from "antd";
import { useSideBarItems } from "./Sidebaritems";
import { MenuOutlined } from "@ant-design/icons";

const { Sider } = Layout;

const Sidebar = ({ collapsed }) => {
  const sideBarItems = useSideBarItems();
  const [selectedItem, setSelectedItem] = useState("1");
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const handleMenuClick = (e) => {
    setSelectedItem(e.key);
    const item = sideBarItems.find((item) => item.key === e.key);
    if (item) {
      navigate(item.target || "/dashboard");
    }
  };

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const path = location.pathname;
    const item = sideBarItems.find((item) => item.target === path);
    if (item) {
      setSelectedItem(item.key);
    }
  }, [location.pathname, sideBarItems]);

  //mobile
  const [menuOpen, setMenuOpen] = useState(false);

  const handleItemClick = (info) => {
    handleMenuClick(info);
    setMenuOpen(false); // Close after selection
  };

  if (isMobile) {
    return (
      <div className="mobile-sidebar-container">
        <MenuOutlined
          onClick={() => setMenuOpen(true)}
          className="hamburger-icon"
        />

        {menuOpen && (
          <div className="mobile-menu-overlay">
            <div className="menu-close-button">
              <button onClick={() => setMenuOpen(false)}>&times;</button>
            </div>
            <Menu
              theme="light"
              mode="inline"
              defaultSelectedKeys={[selectedItem]}
              selectedKeys={[selectedItem]}
              onClick={handleItemClick}
              items={sideBarItems}
              style={{ border: "none" }}
            />
          </div>
        )}
      </div>
    );
  }

  return (
    <Sider
      className="sider-container"
      collapsible
      collapsed={collapsed}
      trigger={null}
      style={{
        border: "none",
        overflow: "auto",
        height: "100vh",
        position: "sticky",
        insetInlineStart: "0",
        top: "0",
        left: "0",
        bottom: "0",
        scrollbarWidth: "thin",
        scrollbarGutter: "stable",
      }}
    >
      <>
        <div
          className="logo-container"
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            padding: collapsed ? "0.5em" : "1em",
          }}
        >
          <div>
            <img
              src={
                "https://stagingonegrad.blob.core.windows.net/fe-assets/logo.png"
              }
              alt="Logo"
              className="logo-image"
              style={{ width: collapsed ? "80px" : "150px", height: "auto" }}
            />
          </div>
        </div>
        <Menu
          className="siderbar-menu"
          theme="light"
          mode="inline"
          defaultSelectedKeys={[selectedItem]}
          selectedKeys={[selectedItem]}
          onClick={handleMenuClick}
          items={sideBarItems}
          style={{
            border: "none",
          }}
        />
      </>
    </Sider>
  );
};

export default Sidebar;
